import React from 'react';

function Bone({ className }) {
  return <div className={`terminal-skeleton rounded-md ${className}`} />;
}

export default function TimelineSkeleton() {
  return (
    <div className="w-full max-w-[1600px] mx-auto space-y-6 px-1" aria-hidden="true">
      <div className="flex justify-center">
        <Bone className="h-6 w-24 rounded-full" />
      </div>
      <div className="flex justify-start">
        <Bone className="h-16 w-[55%] max-w-sm rounded-lg" />
      </div>
      <div className="flex justify-center">
        <Bone className="h-[72px] w-full max-w-[420px] rounded-lg" />
      </div>
      <div className="flex justify-end">
        <Bone className="h-20 w-[48%] max-w-sm rounded-lg" />
      </div>
      <div className="flex justify-center">
        <Bone className="h-[72px] w-full max-w-[420px] rounded-lg" />
      </div>
      <div className="flex justify-start">
        <Bone className="h-14 w-[42%] max-w-sm rounded-lg" />
      </div>
    </div>
  );
}
